export default {
    data() {
        return {
            key: '',
            date: '',
            title: '',
            revenue: '',
            expense: '',
            tax: '',
            reference: '',
            bookNumber: '',
            originalBook: '',
            isClonable: ''
        };
    }
}